import { render, staticRenderFns } from "./rerun_submissions.vue?vue&type=template&id=4dd22ad0&scoped=true&"
import script from "./rerun_submissions.vue?vue&type=script&lang=ts&"
export * from "./rerun_submissions.vue?vue&type=script&lang=ts&"
import style0 from "./rerun_submissions.vue?vue&type=style&index=0&id=4dd22ad0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd22ad0",
  null
  
)

export default component.exports